module.exports = __webpack_public_path__ + "img/7.39c8c6f8.svg";